export const showUploadedVideo = (showVideo: any) => ({
    type: 'showUploadedVideo',
    showVideo: showVideo
});
export const updatePercentage = (uploadPercentage: any) => ({
    type: 'updatePercentage',
    uploadPercentage: uploadPercentage
});
export const updateVideoDetail = (videoDetails: any) => ({
    type: 'updateVideoDetail',
    videoDetails: videoDetails
});